import { OrderRecipientKind } from "../common/order-recipient-kind";
import { OrderSourceKind } from "../common/order-source.kind";

export class OrderCustomerDTO {
	guid: string;
	name: string;
	kind: OrderRecipientKind;
	taxIdentification: string;
	source: OrderSourceKind;
	externalNumber: string;
}